import { ExerciseConfigExecutionTypeEnum } from '@/generated';
import { Timer, Repeat, Timelapse } from '@mui/icons-material';

export const PrimaryValueIcon = (props: { executionType: ExerciseConfigExecutionTypeEnum }) => {
  const { executionType } = props;
  if (executionType === 'reps') return <Repeat fontSize="small" />;
  if (executionType === 'duration') return <Timer fontSize="small" />;
  if (executionType === 'intervals') return <Timelapse fontSize="small" />;
};
